import React, { useState } from "react";
import { Link2, BarChart3, GitBranch } from "lucide-react";
import LinksPanel from "./marketing/LinksPanel";
import ReportPanel from "./marketing/ReportPanel";
import AttributionPanel from "./marketing/AttributionPanel";

const SUB = [
  { id: "links", label: "Links rastreáveis", icon: Link2 },
  { id: "report", label: "Relatórios", icon: BarChart3 },
  { id: "attribution", label: "Atribuição", icon: GitBranch },
];

export default function AdminMarketing() {
  const [sub, setSub] = useState("links");
  return (
    <div data-testid="admin-marketing">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Marketing</h1>
          <p className="mt-1 text-[13px] text-slate-400">Links com UTM, funil por campanha e origem de cada cadastro. GA4 ativo na landing e no app.</p>
        </div>
        <div className="flex gap-1 rounded-xl bg-white/[0.03] ring-1 ring-white/[0.06] p-1">
          {SUB.map((s) => (
            <button key={s.id} onClick={() => setSub(s.id)} data-testid={`mkt-sub-${s.id}`}
              className={`inline-flex items-center gap-2 h-9 px-3 rounded-lg text-[12.5px] transition-colors ${sub === s.id ? "bg-[#38BDF8]/25 text-white ring-1 ring-[#38BDF8]/40" : "text-slate-400 hover:text-white"}`}>
              <s.icon size={14} /> {s.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-6">
        {sub === "links" && <LinksPanel />}
        {sub === "report" && <ReportPanel />}
        {sub === "attribution" && <AttributionPanel />}
      </div>
    </div>
  );
}
